<ng-template #breakdownModal let-modal>
	<div class="modal-content">
		<div class="modal-header">
			<h4>Kit Breakdown</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
		</div>
		<div class="modal-body">
			<div class="row">
				<div class="col-md-4">
					{{activeBom.bomParent}}
				</div>
			</div>
			<div class="row">
				<div class="col-md-4">
					<table>
						<tr>
							<th>Number in Stock</th>
							<th>Number to Breakdown</th>
						</tr>
						<tr>
							<td>{{bdData.parentInStock}}</td>
							<td>
								<mat-form-field>
									<input type="text" class="text-right m-0 p-0" matInput (input)="updateBD($event.target.value)" />
								</mat-form-field>
							</td>
						</tr>
					</table>
				</div>
				<div class="col-md-2">
					<mat-icon>arrow_right_alt</mat-icon>
				</div>
				<div class="col-md-6">
					<table>
						<tr>
							<th>Component</th>
							<th>Number in Stock</th>
							<th>Number per Kit</th>
							<th>Number to Add</th>
						</tr>
						<tr *ngFor="let bomline of bdData.bomlines">
							<td>{{bomline.component}}
							<td>{{bomline.qoh}}</td>
							<td>{{bomline.quantity}}</td>
							<td>{{bomline.qtyadd}}</td>
						</tr>
					</table>
				</div>

			</div>

		</div>

		<div class="modal-footer"><a mat-raised-button style="margin-left: 5px;" (click)="processBreakdown();">Breakdown Kit</a></div>
	</div>
</ng-template>

<!-- modal -->

<!-- modal header -->
<div class="modal-header" [formGroup]="bomForm">
	<h3 class="bom-header">
		<div class="bom-column">
			<div class="bom-row">
				<span *ngIf="!bomParentEditing; else editing">
					<button mat-icon-button (click)="editBomParent()" class="icon-button" matTooltip="Edit BOM">
						<mat-icon>edit</mat-icon>
					</button>
					<b class="bom-title">{{ activeBom.bomParent }}</b>
					<span class="bom-subtitle">| Viewing Bill Of Material Information</span><br />
					<button mat-raised-button color="primary" (click)="breakdown()" class="icon-button breakdown-btn">
						<mat-icon>auto_awesome</mat-icon> Break Down
					</button>
				</span>

				<ng-template #editing>
					<button mat-icon-button (click)="bomForm.get('activeBomParent').valid ? saveAndClose() : validityAlert();" [disabled]="!bomForm.get('activeBomParent').valid" class="icon-button" matTooltip="Save Changes">
						<mat-icon>save</mat-icon>
					</button>
					<b class="bom-title">{{ activeBom.bomParent }}</b>
					<span class="bom-subtitle">| Editing Bill Of Material Information</span>
				</ng-template>
			</div>

			<div class="row gx-3 align-items-center mt-3" *ngIf="bomParentEditing && activeBom">
			  <!-- Effective From -->
			  <div class="col-md-6 d-flex align-items-center">
				<label class="me-2 fw-semibold" >Effective From:</label>
				<mat-form-field appearance="outline" class="w-100">
				  <input matInput
						 type="date"
						 formControlName="activeBomParent_effectiveafter"
						 [value]="activeBom['bomParent_effectiveafter']" />
				</mat-form-field>
			  </div>
			
			  <!-- Effective Until -->
			  <div class="col-md-6 d-flex align-items-center mt-3 mt-md-0">
				<label class="me-2 fw-semibold" >Effective Until:</label>
				<mat-form-field appearance="outline" class="w-100">
				  <input matInput
						 type="date"
						 formControlName="activeBomParent_effectiveto"
						 [value]="activeBom['bomParent_effectiveto']" />
				</mat-form-field>
			  </div>
			</div>
		</div>
	</h3>
	<mat-icon class="close-icon" (click)="close()" matTooltip="Close">close</mat-icon>
</div>


<!-- modal body -->
<div class="modal-body">

	<!-- active bom list -->
	<ng-container *ngIf="activeBom">
	  <div class="row"
		   [formGroup]="bomForm"
		   [ngClass]="bomParentEditing ? 'pe-auto' : 'pe-none disabled'">
		   
		<table class="table table-sm table-bordered table-striped text-center">
		  <thead>
			<tr>
			  <th>Sequence</th>
			  <th>Description</th>
			  <th>Component</th>
			  <th>Location</th>
			  <th class="hidden-column">Effective After</th>
			  <th class="hidden-column">Effective To</th>
			  <th>Quantity</th>
			  <th>Action</th>
			</tr>
		  </thead>
		  <tbody cdkDropList (cdkDropListDropped)="drop($event)">
			<tr cdkDrag cdkDragLockAxis="y" *ngFor="let part of activeBom">
			  <td cdkDragHandle>{{ part.sequence }}</td>
			  <td>{{ part.description }}</td>
			  <td>{{ part.component }}</td>
			  <td>{{ part.loccode }}</td>
	
			  <td class="hidden-column">
				<div class="table-input-wrapper">
				  <mat-form-field appearance="fill" class="full-width">
					<input matInput type="date"
						   formControlName="{{ part.component + '_effectiveafter' }}">
				  </mat-form-field>
				</div>
			  </td>
	
			  <td class="hidden-column">
				<div class="table-input-wrapper">
				  <mat-form-field appearance="fill" class="full-width">
					<input matInput type="date"
						   formControlName="{{ part.component + '_effectiveto' }}">
				  </mat-form-field>
				</div>
			  </td>
	
			  <td>
				<div class="table-input-wrapper narrow">
				  <mat-form-field appearance="fill" class="half-width">
					<input matInput type="number"
						   formControlName="{{ part.component }}">
				  </mat-form-field>
				</div>
			  </td>
	
			  <td>
				<button mat-icon-button (click)="removeComponent(part)">
				  <mat-icon [ngClass]="bomParentEditing ? 'active' : 'inactive'">delete</mat-icon>
				</button>
			  </td>
			</tr>
		  </tbody>
		</table>
	  </div>
	</ng-container>

	<hr>



	<div [ngClass]="bomParentEditing ? '':'hidden'">

		<div class="component-search-row">
		  <mat-form-field appearance="outline" class="component-search-field">
			<input matInput
				   [formControl]="componentlookup"
				   autocomplete="off"
				   placeholder="* Component Search"
				   (keyup.enter)="$event.stopPropagation(); $event.preventDefault(); componentSearch(); $event.target.blur();">
		
			<div matSuffix class="search-suffix">
			  <ng-container *ngIf="searching; else showSearch">
				<mat-progress-spinner
				  mode="indeterminate"
				  diameter="20"
				  strokeWidth="3"
				  color="primary">
				</mat-progress-spinner>
			  </ng-container>
			  <ng-template #showSearch>
				<button mat-icon-button
						type="button"
						class="search-icon-button"
						(click)="$event.stopPropagation(); $event.preventDefault(); componentSearch()">
				  <mat-icon>search</mat-icon>
				</button>
			  </ng-template>
			</div>
		  </mat-form-field>
		</div>


		<div class="table table-responsive text-center searchlist" *ngIf="componentsearching">
			<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
		</div>

		<div class="table table-responsive searchlist" *ngIf="componentitemlist && componentitemlist.length > 1">
			<table mat-table [dataSource]="componentdatasource" class="mat-elevation-z8" *ngIf="componentdatasource">
			  
			  <ng-container matColumnDef="stockid">
				<th mat-header-cell *matHeaderCellDef> Stock ID </th>
				<td mat-cell *matCellDef="let element"> {{element.stockid}} </td>
			  </ng-container>
			
			  <ng-container matColumnDef="description">
				<th mat-header-cell *matHeaderCellDef> Description </th>
				<td mat-cell *matCellDef="let element"> {{element.description}} </td>
			  </ng-container>
			
			  <ng-container matColumnDef="loccode">
				<th mat-header-cell *matHeaderCellDef> Loccode </th>
				<td mat-cell *matCellDef="let element"> {{element.loccode}} </td>
			  </ng-container>
			
			  <ng-container matColumnDef="mfgpart">
				<th mat-header-cell *matHeaderCellDef> MFG Part # </th>
				<td mat-cell *matCellDef="let element"> {{element.mfgpart}} </td>
			  </ng-container>
			
			  <ng-container matColumnDef="action">
				<th mat-header-cell *matHeaderCellDef> Action </th>
				<td mat-cell *matCellDef="let element">
				  <a mat-raised-button (click)="addToBom(element)">Add</a>
				</td>
			  </ng-container>
			
			  <tr mat-header-row *matHeaderRowDef="componentdisplayedColumns"></tr>
			  <tr mat-row
				  *matRowDef="let row; columns: componentdisplayedColumns;"
				  [hidden]="row.stockid === activeBom?.bomParent || isAlreadyInBom(row.stockid)">
				
			  </tr>
			</table>

		</div>

		<mat-paginator #paginator [pageSizeOptions]="[15,25,50]" showFirstLastButtons></mat-paginator>
	</div>

</div>




<!-- </ng-template> -->